/**
 * @format
 * @Description: 产品列表状态机
 * @Autho: 人杰
 * @Date:2019/10/18 11:47
 */

import { action, observable, useStrict } from 'mobx';
import Serv from './ProductListServ';

const CDN_BASE = 'assets';
useStrict(true);
class ProductListMod {
  @observable urlList = [];
  @observable state = {
    appList: []
  };
  /** 导航数据源 */
  @observable
  dataSource = {
    title: '数字营销云产品体系',
    des: `以数字中台为核心，围绕营销、交易、服务的全用户旅程触点构筑的系列产品，赋能新零售创新`,
    list: [
      {
        dataIndex: 'i-Marketing',
        img: `/imgs/home/content_zero_2.png`,
        title: [`i-Marketing`, '营销智能'],
        url: this.urlList[0] + '/#/home/gatewayMgmt/gatewayList',
        advantage: ['解决企业的泛会员营销问题']
      },
      {
        dataIndex: 'i-Sales',
        img: `/imgs/home/content_zero_3.png`,
        title: ['i-Sales', '全渠道销售'],
        url: this.urlList[1] + '/#/home/filterMgmt/filterList',
        advantage: ['构筑无缝的消费体验']
      },
      {
        dataIndex: 'i-Digital',
        img: `/imgs/home/content_zero_1.png`,
        title: [`i-Digital Engine`, '数字中台'],
        url: this.urlList[2] + '/#/',
        advantage: ['驱动企业数字化转型']
      },

      {
        dataIndex: 'i-Service',
        img: `/imgs/home/content_zero_4.png`,
        title: ['i-Service', '智能服务'],
        url: `/servHome/ServHome`,
        advantage: ['全链路智能客户服务']
      }
    ]
  };

  @action getBiz = async payload => {
    let data = await Serv.getBiz(payload);
    return data;
  };

  @action getAppList = async payload => {
    let data = await Serv.getAppList(payload);
    return data;
  };
}

// ES6单例写法
export default new ProductListMod();



// WEBPACK FOOTER //
// ./src/pages/ProductList/ProductListMod.js